export const alertPaths = {
  management: 'alerts-management',
  list: 'alerts/:routineId',
  new: 'alerts/:routineId/new',
  edit: 'alerts/:routineId/:alertId',
};
